import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from "@angular/core";

@Component({
  selector: "app-roles-cta",
  templateUrl: "./roles-cta.component.html",
  styleUrls: ["./roles-cta.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class RolesCtaComponent {
  @Input() public hasAccess = false;

  @Output() public dismiss = new EventEmitter<void>();
}
